/* @ngInject */
function AssetPreviewTabInstructionsController ($rootScope, $scope, $state, $sce, $q, $location, $translate, ToastService, TemplateService, UdsModalService) {
  const getTemplatePropertiesDialogController = () =>
    $q.when(import('../../../arts/dialogs/template-properties/template-properties-dialog.controller'))

  $scope.loading = true
  $scope.usageInstructions = null
  const api = {
    getTemplatePropertiesDialogController,
    _setInstructions,
    _updateCurrentTemplate
  }
  this.getApi = () => api

  activate()

  function activate () {}

  $scope.$watchCollection('template', () => {
    api._setInstructions($scope.template)
  })

  function _setInstructions (template) {
    if (!template) {
      return
    }

    $scope.usageInstructions = $sce.trustAsHtml(template?.details?.suggestions)
    $scope.loading = false
  }

  $scope.copyUsageInstructions = () => {
    if (!$scope.usageInstructions) {
      return
    }

    const text = $scope.usageInstructions
    const sanitizedText = text ? text.$$unwrapTrustedValue().replace(/(<br>|<br \/>)/g, '\r\n').replace(/<[^>]*>/g, '').replace(/(&nbsp;)/g, ' ') : ''
    navigator.clipboard.writeText(sanitizedText)

    ToastService.showSuccessToast($translate.instant('copied'))
  }

  $scope.$on('template-props.reload-data', () => {
    api._updateCurrentTemplate()
  })

  $scope.openTemplateSettings = function () {
    api.getTemplatePropertiesDialogController().then(({ TemplatePropertiesDialogController }) => {
      const templatePropertiesDialog = UdsModalService.createModal({
        controller: TemplatePropertiesDialogController,
        modalName: 'templatePropertiesDialog',
        data: {
          art: $scope.template,
          shouldConvertToTemplate: false,
          isEditing: true,
          isCustomizable: $scope.template.isCustomizable,
          artCollectionId: $scope.template.artCollectionId
        },
        onClose: info => {
          $location.search({ ...$state.params, id: null, template: null })

          if (info && info.wasUpdated) {
            api._updateCurrentTemplate()
            $rootScope.$broadcast('reload-arts-page')
          }
        }
      })

      templatePropertiesDialog.open()
    })
  }

  function _updateCurrentTemplate () {
    TemplateService.getTemplateDetailsForPreview($scope.template.id).then((template) => {
      $scope.template = template
    })
  }
}

export { AssetPreviewTabInstructionsController }
